import React from "react";
import {
	formatContractDueDate,
	normalizeContractDueDate,
} from "../../helpers/formatContractDueDate";

function getDueDateTone(value) {
	const normalized = normalizeContractDueDate(value);
	if (!normalized) return "empty";

	const due = new Date(`${normalized}T12:00:00`);
	const today = new Date();
	today.setHours(12, 0, 0, 0);

	if (due < today) return "past";

	const soon = new Date(today);
	soon.setDate(soon.getDate() + 30);
	if (due <= soon) return "soon";

	return "ok";
}

const toneClasses = {
	empty: "text-default-400",
	past: "bg-danger/10 text-danger",
	soon: "bg-warning/10 text-warning",
	ok: "bg-primary/10 text-primary",
};

export default function ContractDueDateBadge({ value }) {
	const tone = getDueDateTone(value);
	const label = formatContractDueDate(value);

	if (tone === "empty") {
		return <span className={`text-sm font-medium ${toneClasses.empty}`}>—</span>;
	}

	return (
		<span
			className={`inline-flex items-center rounded px-2.5 py-0.5 text-xs font-semibold ${toneClasses[tone]}`}
		>
			{label}
		</span>
	);
}
